import React, { useEffect, useState } from 'react';

// import { AppContext } from 'src/providers/AppContextProvider';
// import { IAppContextState } from 'src/reducers/AppContext';
import ReportGroup from './ReportGroup';
import RecentReports from './RecentReports';
import ReportName from 'src/models/ReportName';
import useFetch from 'use-http';
import IndexReferenceType from 'src/models/IndexReferenceType';

// const ssrsUrl = process.env.REACT_APP_SSRS_URL;

const ReportsPage = () => {
    const { get, response } = useFetch();

    const [reportGroupData, setReportGroupData] = useState<ReportName[]>(undefined);
    const [reportCategories, setReportCategories] = useState<IndexReferenceType[]>(undefined);

    useEffect(() => {
        getReportCategories();
        getReportData();
    }, []);

    const getReportData = async () => {
        const data: ReportName[] = await get(`v1.0/reports/report-group`);

        if (response.ok) {
            setReportGroupData(data);
        }
    };

    const getReportCategories = async () => {
        // TODO: Data in our db is not accurate (across all schemas).
        // Fix up data so that these values are no longer hard coded.

        const data: IndexReferenceType[] = await get(`v1.0/reports/report-categories`);

        if (response.ok) {
            setReportCategories(data);
        }

        let hardCats: IndexReferenceType[] = [
            { id: 1, name: 'Alternative Reports', description: null},
            { id: 2, name: 'GIS Reports', description: null},
            { id: 3, name: 'Lease Acquisition Reports', description: null},
            { id: 4, name: 'Mineral Leasehold Ownership Reports', description: null},
            { id: 5, name: 'Surface Ownership Reports', description: null}
        ];

        setReportCategories(hardCats);
    };

    const displayReportGroups = () => {
        // TODO: Restore this when horizon sequencing is up and running.
        return <ReportGroup name="Core" reports={reportGroupData} categories={reportCategories} />;
    };

    // const appContext = useContext<IAppContextState>(AppContext);

    // const iframeSrc = `${ssrsUrl}&rc:LinkTarget=_self&rc:Toolbar=false&ClientNumber=${appContext.clientNumber}&ProjectNumber=${appContext.projectNumber}`;

    // const ssrsUrl = `https://dlcokc-2v64m02:423/ReportServer/Pages/ReportViewer.aspx?/LMSRPT/Menu&rs:embed=true
    // &rc:LinkTarget=_self&ClientNumber=${appContext.clientNumber}&ProjectNumber=${appContext.projectNumber}`;

    return (
        <div style={{ margin: '1rem' }}>
             <div className="report-page-title">Reports</div>
             <div className="report-group-container">
                <RecentReports />
             </div>
             {(reportGroupData?.length > 0 && reportCategories?.length > 0) && (
                <div className="report-group-container">{displayReportGroups()}</div>
             )}

            {/* <div>
                <iframe
                    referrerPolicy="same-origin"
                    width="100%"
                    height={500}
                    src={iframeSrc}
                    sandbox="allow-scripts allow-same-origin allow-forms allow-downloads allow-popups allow-popups-to-escape-sandbox"
                />
            </div> */}
        </div>
    );
};

export default ReportsPage;



// WEBPACK FOOTER //
// ./src/components/project/sections/ReportComponents/Reports.redesign.tsx